import { Company } from './company';
import { Pagination } from './http';
import { User } from './user-auth';
import { UserProcessStatus } from './user-process';

export interface ManagerOfCompany {
  id: string;
  managerId: string;
  manager?: Partial<User>;
  companyId: string;
  company?: Partial<Company>;
  assignedById?: string;
  assignedBy?: Partial<User>;
  assignedAt?: Date;
}

/**
 * When creating manager you must provide managingCompanies along with manager basic data!
 */
export interface CreateManagerOpts {
  email: string;
  name: string;
  companyId: string;
  languageId: string;
  telephoneNumber?: string | null;
  managingCompanies: string[]; // Array of UUIDs (companiesIds)
}

/**
 * When updating manager basic opts you mustn't provide 'managingCompanies' (separate endpoint)
 */
export interface UpdateManagerOpts {
  email?: string;
  name?: string;
  telephoneNumber?: string;
  companyId?: string;
  languageId?: string;
}

export interface SearchManagersOfCompanyOpts extends Pagination {
  // required
  companyId: string;
  // name, email
  query?: string;
  showDeleted?: boolean;
  showInactive?: boolean;
}

// ---- AS MANAGER
// Payload sent by manager to search processes of foreigners he can 'manage'
export interface SearchProcessesOfManagedEmployees extends Pagination {
  companiesIds: string[]; // from companies he's assigned to
  status?: UserProcessStatus;
  query?: string;
}
